export const kTextTileType = "CodapText"
export const kV2TextDGType = "DG.TextView"
export const kV2TextDIType = "text"
export const kTextTileClass = "codap-text"
